const TOASTER_POSITION = 'b-toaster-top-center'
const AUTO_DISMISS_DELAY = 3000;
export default {
  methods: {
    notify(toaster, content, title = null, variant = 'info', autoHide = true, append = false) {
      toaster.toast(
        content,
        {
          title: title,
          toaster: TOASTER_POSITION,
          variant: variant,
          noAutoHide: !autoHide,
          appendToast: append,
          autoHideDelay: AUTO_DISMISS_DELAY,
          solid:true,
          isStatus: true,
          toastClass: 'alternate',
        }
      );
    }
  }
}
